"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetentionHighchartsSettingsRetentionTableComponent = void 0;
const antd_1 = require("antd");
const React = __importStar(require("react"));
const react_1 = require("react");
const icons_1 = require("@ant-design/icons");
const RetentionTableModal_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/retention/RetentionTableModal");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const RetentionHighchartsSettingsRetentionTableComponent = (props) => {
    const isMounted = (0, isMounted_1.default)();
    const [retentionTableModalVisibility, setRetentionTableModalVisibility] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0, title: "N Day Retention Table" });
    const onRetentionTableModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            // console.log("onRetentionTableModalDestroy");
            setRetentionTableModalVisibility({ visible: false });
        }
    }, [isMounted]);
    const onClickOpenTable = (0, react_1.useCallback)(() => {
        setRetentionTableModalVisibility({ visible: true, nonce: retentionTableModalVisibility.nonce + 1 });
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement(RetentionTableModal_1.RetentionTableModal, { key: `${retentionTableModalVisibility.nonce}`, visible: retentionTableModalVisibility.visible, title: retentionTableModalVisibility.title, onDestroy: onRetentionTableModalDestroy }),
        React.createElement(antd_1.Button, { type: "default", icon: React.createElement(icons_1.TableOutlined, null), disabled: props.disabled, onClick: onClickOpenTable }));
};
exports.RetentionHighchartsSettingsRetentionTableComponent = RetentionHighchartsSettingsRetentionTableComponent;
